<template>
    <div class="delivery-quotation-letter" title="Запрос на получение котировки" v-if="quotation && quotation.data">
      <template v-if="quotation.updated_at">
        <p style="margin: 10px 0px 20px 0;"><em>Версия запроса от {{ quotation.updated_at }}</em></p>
      </template>

      <!-- Тип перевозки -->
      <template v-if="quotation.data && quotation.data.supply_way">
          <p style="margin: 0px 0px 5px 0;"><strong>Направление перевозки:</strong> {{ quotation.data.supply_way }}</p>
        </template>
      <!-- Тип перевозки -->
      <template v-if="quotation.data.transport_types_id">
          <p style="margin: 0px 0px 5px 0;"><strong>Тип перевозки:</strong> {{ getReferenceProperty(quotation.data.transport_types_id) }}</p>
      </template>

      <!-- Выбранные типы перевозок для расчета -->
      <template v-if="quotation.data.selected_transport_types_id && quotation.data.selected_transport_types_id.length">
          <p style="margin: 0px 0px 5px 0;"><strong>Типы перевозок на расчет:</strong> {{ quotation.data.selected_transport_types_id.map(getReferenceProperty).join(', ') }}</p>
      </template>
  
      <template v-if="quotation.data.set_delivery_conditions_ids && quotation.data.set_delivery_conditions_ids.length">
          <p style="margin: 0px 0px 5px 0;"><strong>Условия поставки:</strong> {{ quotation.data.set_delivery_conditions_ids.map(getReferenceProperty).join(', ') }}</p>
      </template>
        
      <!-- Место загрузки -->
      <template v-if="quotation.data.loading_places && quotation.data.loading_places.length">
          <p style="margin: 0px 0px 5px 0;"><strong>Место загрузки:</strong></p>
          <ul style="padding-left: 15px;">
            <li v-for="(place, index) in quotation.data.loading_places" :key="`loading-place-${index}`">
              {{ getReferenceProperty(place.country_id) }}<template v-if="place.city">, {{ place.city }}</template>, {{ place.address }}
            </li>
          </ul>
      </template>
      
      <!-- Место разгрузки -->
      <template v-if="quotation.data.unloading_places && quotation.data.unloading_places.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Место разгрузки:</strong></p>
        <ul style="padding-left: 15px;">
          <li v-for="(place, index) in quotation.data.unloading_places" :key="`unloading-place-${index}`">
            {{ getReferenceProperty(place.country_id) }}<template v-if="place.city">, {{ place.city }}</template>, {{ place.address }}
          </li>
        </ul>
      </template>
  
      <!-- Место растаможки -->
      <template v-if="quotation.data.clearance_places && quotation.data.clearance_places.length">
          <p style="margin: 0px 0px 5px 0;"><strong>Место растаможки:</strong></p>
          <ul style="padding-left: 15px;">
              <li v-for="(place, index) in quotation.data.clearance_places" :key="`clearance-place-${index}`">
              {{ getReferenceProperty(place.country_id) }}<template v-if="place.city">, {{ place.city }}</template>, {{ place.address }}
              </li>
          </ul>
      </template>
  
      <!-- Место затаможки -->
      <template v-if="quotation.data.customs_places && quotation.data.customs_places.length">
          <p style="margin: 0px 0px 5px 0;"><strong>Место затаможки:</strong></p>
          <ul style="padding-left: 15px;">
            <li v-for="(place, index) in quotation.data.customs_places" :key="`customs-place-${index}`">
              {{ getReferenceProperty(place.country_id) }}<template v-if="place.city">, {{ place.city }}</template>, {{ place.address }}
            </li>
          </ul>
      </template>
    
      <!-- Описание груза -->
      <template v-if="quotation.data.cargo_name">
          <p style="margin: 0px 0px 5px 0;"><strong>Наименование груза:</strong> {{ quotation.data.cargo_name }}</p>
      </template>
      <template v-if="quotation.data.cargo_details">
          <p style="margin: 0px 0px 5px 0;"><strong>Описание груза:</strong> {{ quotation.data.cargo_details }}</p>
      </template>
      <template v-if="quotation.data.cargo_code">
          <p style="margin: 0px 0px 5px 0;"><strong>Код ТН ВЭД:</strong> {{ quotation.data.cargo_code }}</p>
      </template>
  
      <template v-if="quotation.data.adr && quotation.data.adr != 'Не знаю'">
          <p style="margin: 0px 0px 5px 0;"><strong>{{ quotation.data.adr }}</strong></p>
      </template>
      <template v-if="quotation.data.stackable && quotation.data.stackable != 'Не знаю'">
          <p style="margin: 0px 0px 5px 0;"><strong>{{ quotation.data.stackable }}</strong></p>
      </template>
      <template v-if="quotation.data.cargoType && quotation.data.cargoSize">
          <p style="margin: 0px 0px 5px 0;"><strong>Тип груза:</strong> {{ quotation.data.cargoType }}, {{ quotation.data.cargoSize }}</p>
      </template>
    

      <template v-if="quotation.data.packaging_type">
        <p style="margin: 0px 0px 5px 0;"><strong>Вид упаковки:</strong> {{ quotation.data.packaging_type }}</p>
      </template>
      <template v-if="quotation.data.dimensions && (quotation.data.dimensions.width || quotation.data.dimensions.height || quotation.data.dimensions.volume || quotation.data.dimensions.length) || quotation.data.gross_weight || quotation.data.number_of_places">
        <p style="margin: 0px 0px 5px 0;"><strong>Размеры и объем груза:</strong>
          <span>
            {{ [
                quotation.data.gross_weight ? `Вес брутто груза: ${quotation.data.gross_weight} кг` : '',
                quotation.data.dimensions && quotation.data.dimensions.length ? `Длина: ${quotation.data.dimensions.length} м` : '',
                quotation.data.dimensions && quotation.data.dimensions.width ? `Ширина: ${quotation.data.dimensions.width} м` : '',
              quotation.data.dimensions && quotation.data.dimensions.height ? `Высота: ${quotation.data.dimensions.height} м` : '',
              quotation.data.dimensions && quotation.data.dimensions.volume ? `Объем: ${quotation.data.dimensions.volume} м³` : '',
              quotation.data.number_of_places ? `Кол-во мест: ${quotation.data.number_of_places}` : ''
            ].filter(Boolean).join(', ') }}
          </span>
        </p>
      </template>
      <template v-if="quotation.data.dimensions && quotation.data.dimensions.details">
        <p style="margin: 0px 0px 5px 0;"><strong>Подробнее о габаритах:</strong> {{ quotation.data.dimensions.details }}</p>
      </template>

      <!-- Размеры грузовых мест -->
      <template v-if="quotation.data.cargo_places && quotation.data.cargo_places.length">
          <p style="margin: 0px 0px 5px 0;"><strong>Размеры грузовых мест:</strong></p>
          <ul style="padding-left: 15px;">
              <li v-for="(place, index) in quotation.data.cargo_places" :key="`cargo-place-${index}`">
                  {{ place.length }}см x {{ place.width }}см x {{ place.height }}см, 
                  {{ place.quantity }} {{ place.quantity === 1 ? 'место' : 'мест' }}<template v-if="place.packaging_type">, {{ place.packaging_type }}</template>
              </li>
          </ul>
      </template>

      <template v-if="quotation.data.hasOwnProperty('isStackingOfCargo')">
        <p style="margin: 0px 0px 5px 0;"><strong>Штабелировка груза:</strong> {{ quotation.data.isStackingOfCargo ? 'Можно' : 'Нельзя' }}</p>
      </template>
  
      <!-- Дата готовности -->
      <template>
          <p style="margin: 0px 0px 5px 0;" v-if="quotation.data.isIndicative"><strong>Этот запрос - индикатив, поставка возможно не состоится.</strong></p>
          <p style="margin: 0px 0px 5px 0;" v-if="quotation.data.next_transport_date"><strong>Дата готовности груза: </strong>{{ formattedDate(quotation.data.next_transport_date)}}</p>
      </template>  
    
      <!-- Типы и виды транспортных средств -->
      <template v-if="quotation.data.transport_types_and_kinds && quotation.data.transport_types_and_kinds.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Необходимые типы и виды транспортных средств:</strong></p>
        <ul style="padding-left: 15px;">
          <li v-for="(transport, index) in quotation.data.transport_types_and_kinds" :key="`transport_types_and_kinds-${index}`">
            <b style="text-transform: none;">{{ transport.quantity }} шт.</b>&nbsp;{{ transport.transport_category_name }}, {{ transport.transport_item_name }}
          </li>
        </ul>
      </template>    
  
      <template v-if="quotation.data.additional_terms">
          <p style="margin: 0px 0px 5px 0;"><strong>Дополнительные условия:</strong> {{ quotation.data.additional_terms }}</p>
      </template>
        
      <!-- Возят ли в обратном направлении -->
      <template v-if="quotation.data.reverse_direction === 'Да'">
        <p style="margin: 0px 0px 5px 0;"><strong>Будет обратная загрузка.</strong> {{ quotation.data.reverse_details }}</p>
      </template>
  
      <!-- Периодичность поставок -->
      <template v-if="quotation.data.supply_frequency_id">
        <p style="margin: 0px 0px 5px 0;"><strong>Периодичность поставок:</strong> {{ getReferenceProperty(quotation.data.supply_frequency_id) }}, количество: {{ quotation.data.supply_count }}</p>
      </template>
  
      <!-- Предпочтения по транзиту -->
      <template v-if="quotation.data.transit_directions_ids && quotation.data.transit_directions_ids.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Предпочтения по транзиту:</strong> {{ quotation.data.transit_directions_ids.map(getReferenceProperty).join(', ') }}</p>
      </template>
  
      <!-- Специальные требования к партнерам -->
      <template v-if="quotation.data.special_partner_requirements_ids && quotation.data.special_partner_requirements_ids.length">
        <p style="margin: 0px 0px 5px 0;"><strong>Специальные требования к партнерам:</strong> {{ quotation.data.special_partner_requirements_ids.map(getReferenceProperty).join(', ') }}</p>
      </template>
  
      <!-- Стоимость груза -->
      <template v-if="quotation.data.cargo_invoice_value || quotation.data.cargo_declared_value">
        <p style="margin: 0px 0px 5px 0;">
          <span v-if="quotation.data.cargo_invoice_value">
            <strong>Инвойсовая стоимость:</strong> {{ formatNumber(quotation.data.cargo_invoice_value) }} {{ getReferenceProperty(quotation.data.cargo_invoice_currency_id) }}
            <span v-if="quotation.data.cargo_declared_value">, </span>
          </span>
          <span v-if="quotation.data.cargo_declared_value">
            <strong>Объявленная стоимость:</strong> {{ formatNumber(quotation.data.cargo_declared_value) }} {{ getReferenceProperty(quotation.data.cargo_declared_currency_id) }}
          </span>
        </p>
      </template>
  
      <!-- Условия оплаты -->
      <template v-if="quotation.data.payment_terms && quotation.data.payment_terms !== 'Не знаю'">
        <p style="margin: 0px 0px 5px 0;"><strong>Условия оплаты:</strong> {{ quotation.data.payment_terms }}, <span style="text-transform: lowercase;"> 
          <template v-if="quotation.data.payment_terms === 'Предоплата'">
            процент предоплаты: {{ quotation.data.prepayment_percentage }}%, {{ quotation.data.prepaymentComment }}
          </template>
          <template v-if="quotation.data.payment_terms === 'Постоплата'">
            {{ quotation.data.payment_from_copies }}, {{ quotation.data.payment_period }} {{ formatDays(quotation.data.payment_period) }} (<span style="text-transform: lowercase;">{{ quotation.data.payment_period_type }}</span>)
          </template>
        </span></p>
      </template>

      <OrderServiceQuotationAnswerForms
        v-if="shouldShowAnswers && !isClient"
        :order-id="quotation.order_id"
        :order-service-id="quotation.order_service_id"
        :selected-transport-types="quotation.data && quotation.data.selected_transport_types_id ? quotation.data.selected_transport_types_id : []"
        :order-service-quotation-id="quotation.id"
        :order-reference-status-id="quotation.order_reference_status_id || null"
        :show-data-only="true"
      />
    </div>
  </template>
  
<script>
import { mapGetters } from 'vuex';

import OrderServiceQuotationAnswerForms from '@/components/orders/orderServiceQuotation/OrderServiceQuotationAnswerForms.vue';
import { formattedDate } from '@/mixins/textFilters';

export default {
  components: {
    OrderServiceQuotationAnswerForms,
  },
  props: {
      quotation: { type: Object, required: true },
      showAnswers: { type: Boolean, default: false },
  },
    mixins: [
      formattedDate,
    ], 
    data() {
        return {};
    },     
    computed: {
      ...mapGetters("auth", ["currentUser"]),
      isClient() {
        return this.currentUser.role.includes('client');
      },
      referenceProperties() {
        return this.$store.getters.REFERENCE_PROPERTIES;
      },
      shouldShowAnswers() {
        const selectedTypes = (this.quotation && this.quotation.data && this.quotation.data.selected_transport_types_id) || [];
        return Boolean(
          this.showAnswers &&
          this.quotation &&
          this.quotation.id &&
          this.quotation.order_id &&
          this.quotation.order_service_id &&
          Array.isArray(selectedTypes) &&
          selectedTypes.length
        );
      }
    },
    mounted() {
    },    
    methods: {
      getReferenceProperty(id) {
        return this.referenceProperties[id] ? this.referenceProperties[id].text : 'Неизвестно';
      },
      formatNumber(value) {
        if (typeof value === 'string') {
          const number = parseFloat(value.replace(',', '.'));
          return isNaN(number) ? value : number.toLocaleString();
        }
        return value.toLocaleString();
      },
      formatDays(days) {
        if (days === 1) return 'день';
        if (days >= 2 && days <= 4) return 'дня';
        if (days >= 5 && days <= 20) return 'дней';
        if (days % 10 === 1 && days % 100 !== 11) return 'день';
        if ([2, 3, 4].includes(days % 10) && ![12, 13, 14].includes(days % 100)) return 'дня';
        return 'дней';
      },
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .delivery-quotation-letter {
    line-height: 16px;
  
    p {
      margin-bottom: 12px;
    }
    b, strong {
      text-transform: none;
    }  
  
    ul { 
      list-style: disc; 
      margin-left: 25px;
    }
  }
  </style>
  